<template>
  <v-card
    class="ident-detail-card"
    color="grey lighten-2"
    flat
  >
    <v-card>
      <v-card-title class="toolbar primary white--text title">
        <v-icon
          dark
          color="white"
          class="mr-2"
        >
          assignment
        </v-icon>
        Transaction Details: {{ transaction.extIdentifier }}
        <v-spacer />
        <v-chip
          outline
          color="white"
        >
          {{ transaction.status }}
        </v-chip>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-layout
            row
            wrap
            class="pa-0"
          >
            <v-flex
              flex
              xs4
            >
              <v-card class="ma-2 pa-2">
                <v-card-title class="toolbar info white--text subheading">
                  <span>From</span>
                </v-card-title>
                <v-card-text>
                  <v-layout fill-height>
                    <v-flex
                      xs12
                      align-end
                      flexbox
                    >
                      <v-text-field
                        :label="'User Id'"
                        :value="transaction.fromUserId"
                        readonly
                      />
                      <v-text-field
                        :label="'Wallet Name'"
                        :value="transaction.wallet"
                        readonly
                      />
                      <v-text-field
                        :label="'Wallet Address'"
                        :value="transaction.from"
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              flex
              xs4
            >
              <v-card class="ma-2 pa-2">
                <v-card-title class="toolbar info white--text subheading">
                  <span>To</span>
                </v-card-title>
                <v-card-text>
                  <v-layout fill-height>
                    <v-flex
                      xs12
                      align-end
                      flexbox
                    >
                      <v-text-field
                        :label="'User Id'"
                        :value="transaction.toUserId"
                        readonly
                      />
                      <v-text-field
                        :label="'Wallet Name'"
                        :value="transaction.toWallet"
                        readonly
                      />
                      <v-text-field
                        :label="'Wallet Address'"
                        :value="transaction.to"
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              flex
              xs4
            >
              <v-card class="ma-2 pa-2">
                <v-card-title class="toolbar info white--text subheading">
                  <span>More details</span>
                </v-card-title>
                <v-card-text>
                  <v-layout fill-height>
                    <v-flex
                      xs12
                      align-end
                      flexbox
                    >
                      <v-text-field
                        :label="'RequestId'"
                        :value="transaction.requestId"
                        readonly
                      />
                      <v-textarea
                        :label="'Error Details'"
                        :value="transaction.errorDetails"
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- <pre>{{ transaction }}</pre> -->
            <v-flex
              class="pa-2"
              xs12
            >
              <v-btn
                dark
                flat
                block
                color="primary"
                @click.stop="isDebugDialogActive = true"
              >
                <v-icon class="pr-2">
                  adb
                </v-icon>
                Debug
              </v-btn>
            </v-flex>
          </v-layout>
          <DebugDialog
            :visible="isDebugDialogActive"
            :debug-object="transaction"
            :title="'Debug Transaction'"
            @close="isDebugDialogActive = false"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import _ from 'lodash';
import DebugDialog from '@/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog';

export default {
  name: 'VaultTransactionDetail',
  components: {
    DebugDialog,
  },
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDebugDialogActive: false,
    };
  },
};
</script>
<style lang="scss">
.ident-detail-card {
  padding: 32px;
  .v-card__title {
    padding: 16px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vault/VaultTransactionDetail.vue